import { render, staticRenderFns } from "./saveClass.vue?vue&type=template&id=33d63d3e"
import script from "./saveClass.vue?vue&type=script&lang=js"
export * from "./saveClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports